'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';
import type { PlayScheduleSurface } from '@/lib/play-schedule';

type Props = { own: boolean; surface: PlayScheduleSurface; slotsCount: number };

/**
 * Sends `play_schedule_viewed` once per mount. Render it next to the heatmap
 * only when the schedule is actually shown. Renders nothing itself, so it can
 * sit inside server components (the public profile) too.
 */
export function PlayScheduleViewed({ own, surface, slotsCount }: Props) {
  useEffect(() => {
    posthog.capture('play_schedule_viewed', { platform: 'web', own, surface, slots_count: slotsCount });
    // Once per mount by design; later prop changes aren't a new view.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
